module.exports = __webpack_public_path__ + "assets/roboto-italic.b3780db76cbc604e92914bc9caf5fab1801f58ee606d1fc0206e3a819b7666cf.woff2";